// components/debug-panel.tsx
"use client";

import React, {useState } from 'react';

import { useAuthStore } from '@/app/auth/services_and_hooks/authStore';
import { useAuthHook } from '@/app/auth/services_and_hooks/useAuthHook';

export function DebugPanel() {
  // --- Use the new hook ---
  const {
      user,
      session,
      isLoading,
      isAuthenticated,
      // --- FIX: Get the actual errors from the hook ---
      sessionError,
      userDataError,
      // --- END FIX ---
      profile,
      hasCompletedOnboarding
  } = useAuthHook();

  const [isExpanded, setIsExpanded] = useState(false);

  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  // --- FIX: Determine error state from actual errors ---
  const hasError = !!sessionError || !!userDataError; // Check if any specific error exists
  const errorMessages = [sessionError?.message, userDataError?.message].filter(Boolean).join('; '); // Combine error messages
  // --- END FIX ---

  // Determine status text and color based on hook state
  let statusText = 'Unknown';
  let statusColor = 'bg-gray-500 text-white'; // Default for light theme base

  if (isLoading) {
    statusText = 'Loading...';
    statusColor = 'bg-blue-500 text-white';
  } else if (hasError) {
    statusText = 'Error';
    statusColor = 'bg-red-500 text-white';
  } else if (isAuthenticated) {
    statusText = 'Logged In';
    statusColor = 'bg-green-500 text-white';
  } else {
    statusText = 'Not Logged In';
    // statusColor remains gray
  }

  const authStore = useAuthStore.getState(); // Get store state for comparison

  // const handleForceReset = async () => {
  //    if (window.confirm('Are you sure you want to force reset the auth state and sign out?')) {
  //        await forceSignOut();
  //    }
  // };

  return (
    <div className="fixed bottom-4 left-4 z-[100]">
      <div className="bg-gray-50 border border-gray-300 rounded-lg shadow-lg overflow-hidden max-w-lg">
        <div
          className={`flex items-center justify-between p-2 ${statusColor} cursor-pointer`}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <h3 className="text-sm font-medium text-white">
            Auth Debug ({statusText})
          </h3>
          <button className="text-gray-200 hover:text-white">
            {isExpanded ? '▲' : '▼'}
          </button>
        </div>

        {isExpanded && (
          <div className="p-3 text-xs text-gray-700">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
              {/* Hook State */}
              <div>
                <div className="font-semibold text-gray-800 mb-1">Hook State (`useAuthHook`):</div>
                <div className="bg-gray-100 border border-gray-200 p-2 rounded overflow-auto max-h-48">
                  <pre className="text-gray-600">
                    {JSON.stringify({
                      isLoading,
                      isAuthenticated,
                      hasCompletedOnboarding,
                      // --- FIX: Show actual errors ---
                      sessionError: sessionError?.message || null,
                      userDataError: userDataError?.message || null,
                      // --- END FIX ---
                      user: user ? { id: user.id, email: user.email, verified: user.email_confirmed_at } : null,
                      session: session ? { expires_at: session.expires_at } : null,
                      profile: profile ? { id: profile.id, onboarding_completed_at: profile.onboarding_completed_at } : null,
                    }, null, 2)}
                  </pre>
                </div>
              </div>

              {/* Zustand Store State (Direct) */}
              <div>
                <div className="font-semibold text-gray-800 mb-1">Zustand Store (Direct):</div>
                 <div className="bg-gray-100 border border-gray-200 p-2 rounded overflow-auto max-h-48">
                  <pre className="text-gray-600">
                    {JSON.stringify({
                      isLoading: authStore.isLoading,
                      isAuthenticated: authStore.isAuthenticated,
                      hasCompletedOnboarding: authStore.hasCompletedOnboarding,
                      user: authStore.user ? { id: authStore.user.id, email: authStore.user.email } : null,
                      session: authStore.session ? { expires_at: authStore.session.expires_at } : null,
                      profile: authStore.profile ? { id: authStore.profile.id, onboarding_completed_at: authStore.profile.onboarding_completed_at } : null
                    }, null, 2)}
                  </pre>
                </div>
              </div>
            </div>

            {/* Error Messages Display */}
            {hasError && (
              <div className="mt-3 p-2 bg-red-50 border border-red-200 rounded">
                <div className="font-semibold text-red-800 mb-1">Errors:</div>
                <div className="text-red-600 text-xs">{errorMessages}</div>
              </div>
            )}

            {/* Buttons remain the same */}
            <div className="grid grid-cols-2 gap-2 mb-2">{/* ... */}</div>
            <div className="grid grid-cols-2 gap-2">{/* ... */}</div>
            <div className="mt-4">{/* ... Force Reset Button ... */}</div>
          </div>
        )}
      </div>
    </div>
  );
}